import { render, staticRenderFns } from "./DialogDeleteAll.vue?vue&type=template&id=784dba68&scoped=true&"
import script from "./DialogDeleteAll.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteAll.vue?vue&type=script&lang=js&"
import style0 from "./DialogDeleteAll.vue?vue&type=style&index=0&id=784dba68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784dba68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VCard,VIcon,VSelect})
